export default function UsersPage() {
  return (
    <section className="card content-card">
      <h2>Gestion de Usuarios</h2>
      <p className="subtitle">
        Base inicial para administrar perfiles y permisos del sistema.
      </p>
      <ul className="checklist">
        <li>Registrar usuario</li>
        <li>Listar usuarios</li>
        <li>Editar usuario</li>
        <li>Desactivar usuario</li>
      </ul>
    </section>
  );
}
